import React, { useState } from "react";
import Tabs from "../../../Component/DigitalMarketing/Tabs";
import { useGetConsultantSummaryQuery } from "../../../Service/dashboard";
import MonthFilterSelect from "../../../Component/DigitalMarketing/MonthFilter";

const ConsultantSummary = () => {
  const [selectedMonth, setSelectedMonth] = useState("this Month");

  const monthOptions = [
    { value: "this Month", label: "This Month" },
    { value: "previous Month", label: "Previous Month" },
  ];

  const { data:appointmentData, refetch, isLoading } = useGetConsultantSummaryQuery(selectedMonth, {
    refetchOnMountOrArgChange: true,
  });

  const data = [
    {
      id: "1",
      label: "Total Consultant",
      count: `${appointmentData?.data[0]?.totalConsultantCount}`,
      bgcolor: true,
    },
    {
      id: "2",
      label: "Active Consultant",
      count: `${appointmentData?.data[0]?.activeConsultantCount}`,
    },
    {
      id: "3",
      label: "New Consultant",
      count: `${appointmentData?.data[0]?.newConsultantCount}`,
    },
  ];
  return (
    <div>
       <div className="d-flex justify-content-between">
        <div>
          <span className="dashboard-heading mb-4">Consultant</span>
        </div>
        <div>
          <MonthFilterSelect
            value={selectedMonth}
            onChange={setSelectedMonth}
            options={monthOptions}
          />
        </div>
      </div>
      <div className="row gap-2">
        {data?.map((d: any) => (
          <div
            className="cards  mt-3"
            key={d?.id}
            style={{ backgroundColor: d?.bgcolor ? "#EFF8FF" : "#fff",width:"223px" }}
          >
            <div>
              <span className="f-16 fw-400">{d?.label}</span>
            </div>
            <div>
              <span className="f-32 fw-600">{d?.count}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConsultantSummary;
